import type { IRangeValue } from "~/types/range";

export const DEFAULT_RANGE_SLIDER_MIN = 0;
export const DEFAULT_RANGE_SLIDER_MAX = 100;
export const DEFAULT_RANGE_SLIDER_STEP = 1;

export const toSliderValue = (
  value: IRangeValue | undefined,
  min: number,
  max: number
): [number, number] => [
  Math.min(Math.max(value?.min ?? min, min), max),
  Math.min(Math.max(value?.max ?? max, min), max),
];

export const toEmittedValue = (
  value: [number, number],
  min: number,
  max: number
): IRangeValue => ({
  min: value[0] === min ? undefined : value[0],
  max: value[1] === max ? undefined : value[1],
});

export const isSameRangeValue = (a?: IRangeValue, b?: IRangeValue) =>
  (a?.min ?? null) === (b?.min ?? null) &&
  (a?.max ?? null) === (b?.max ?? null);
